// This file is AUTOGENERATED, do not edit it manually!!!

import { menu as menude } from './menuResx.de';
import { menu as menuen } from './menuResx.en';
import { menu as menuen_risk } from './menuResx.en_risk';
import { menu as menues } from './menuResx.es';
import { menu as menufr } from './menuResx.fr';
import { menu as menuit } from './menuResx.it';
import { menu as menunl } from './menuResx.nl';
import { menu as menupl } from './menuResx.pl';
import { menu as menupt } from './menuResx.pt';
import { menu as menuru } from './menuResx.ru';
import { menu as menusk } from './menuResx.sk';
import { menu as menusv } from './menuResx.sv';
import { menu as menutr } from './menuResx.tr';

const langMap: { [k: string]: Partial<typeof menuen> } = {
    de: menude,
    en: menuen,
    en_risk: menuen_risk,
    es: menues,
    fr: menufr,
    it: menuit,
    nl: menunl,
    pl: menupl,
    pt: menupt,
    ru: menuru,
    sk: menusk,
    sv: menusv,
    tr: menutr,
};

/* tslint:disable: max-line-length */
export const menuResx = {
    get access_levels() {
        return langMap[ep.resxCulture].access_levels || langMap.en.access_levels;
    },
    get activityList() {
        return langMap[ep.resxCulture].activityList || langMap.en.activityList;
    },
    get addlicenses() {
        return langMap[ep.resxCulture].addlicenses || langMap.en.addlicenses;
    },
    get approvals() {
        return langMap[ep.resxCulture].approvals || langMap.en.approvals;
    },
    get archive() {
        return langMap[ep.resxCulture].archive || langMap.en.archive;
    },
    get billingReport() {
        return langMap[ep.resxCulture].billingReport || langMap.en.billingReport;
    },
    get builder() {
        return langMap[ep.resxCulture].builder || langMap.en.builder;
    },
    get commonReports() {
        return langMap[ep.resxCulture].commonReports || langMap.en.commonReports;
    },
    get companySettings() {
        return langMap[ep.resxCulture].companySettings || langMap.en.companySettings;
    },
    get customers() {
        return langMap[ep.resxCulture].customers || langMap.en.customers;
    },
    get customfields() {
        return langMap[ep.resxCulture].customfields || langMap.en.customfields;
    },
    get dashboard() {
        return langMap[ep.resxCulture].dashboard || langMap.en.dashboard;
    },
    get days_left() {
        return langMap[ep.resxCulture].days_left || langMap.en.days_left;
    },
    get featurelabs() {
        return langMap[ep.resxCulture].featurelabs || langMap.en.featurelabs;
    },
    get forms() {
        return langMap[ep.resxCulture].forms || langMap.en.forms;
    },
    get generalOptions() {
        return langMap[ep.resxCulture].generalOptions || langMap.en.generalOptions;
    },
    get guestPortal() {
        return langMap[ep.resxCulture].guestPortal || langMap.en.guestPortal;
    },
    get integrations() {
        return langMap[ep.resxCulture].integrations || langMap.en.integrations;
    },
    get invoices() {
        return langMap[ep.resxCulture].invoices || langMap.en.invoices;
    },
    get jobroles() {
        return langMap[ep.resxCulture].jobroles || langMap.en.jobroles;
    },
    get logout() {
        return langMap[ep.resxCulture].logout || langMap.en.logout;
    },
    get mobile_apps() {
        return langMap[ep.resxCulture].mobile_apps || langMap.en.mobile_apps;
    },
    get myassignments() {
        return langMap[ep.resxCulture].myassignments || langMap.en.myassignments;
    },
    get myoptions() {
        return langMap[ep.resxCulture].myoptions || langMap.en.myoptions;
    },
    get mySettingsNotifications() {
        return langMap[ep.resxCulture].mySettingsNotifications || langMap.en.mySettingsNotifications;
    },
    get mySettingsOptions() {
        return langMap[ep.resxCulture].mySettingsOptions || langMap.en.mySettingsOptions;
    },
    get mySettingsProfile() {
        return langMap[ep.resxCulture].mySettingsProfile || langMap.en.mySettingsProfile;
    },
    get myvacations() {
        return langMap[ep.resxCulture].myvacations || langMap.en.myvacations;
    },
    get notificationCenter() {
        return langMap[ep.resxCulture].notificationCenter || langMap.en.notificationCenter;
    },
    get notifications() {
        return langMap[ep.resxCulture].notifications || langMap.en.notifications;
    },
    get payrollReport() {
        return langMap[ep.resxCulture].payrollReport || langMap.en.payrollReport;
    },
    get portfolios() {
        return langMap[ep.resxCulture].portfolios || langMap.en.portfolios;
    },
    get powerbi() {
        return langMap[ep.resxCulture].powerbi || langMap.en.powerbi;
    },
    get presetsHideViewTooltip() {
        return langMap[ep.resxCulture].presetsHideViewTooltip || langMap.en.presetsHideViewTooltip;
    },
    get presetsListTitle() {
        return langMap[ep.resxCulture].presetsListTitle || langMap.en.presetsListTitle;
    },
    get projectCentricView() {
        return langMap[ep.resxCulture].projectCentricView || langMap.en.projectCentricView;
    },
    get ratecards() {
        return langMap[ep.resxCulture].ratecards || langMap.en.ratecards;
    },
    get recommend_us() {
        return langMap[ep.resxCulture].recommend_us || langMap.en.recommend_us;
    },
    get reportgenerator() {
        return langMap[ep.resxCulture].reportgenerator || langMap.en.reportgenerator;
    },
    get reports() {
        return langMap[ep.resxCulture].reports || langMap.en.reports;
    },
    get resourcesPage() {
        return langMap[ep.resxCulture].resourcesPage || langMap.en.resourcesPage;
    },
    get roles() {
        return langMap[ep.resxCulture].roles || langMap.en.roles;
    },
    get search() {
        return langMap[ep.resxCulture].search || langMap.en.search;
    },
    get sharedProjectPlans() {
        return langMap[ep.resxCulture].sharedProjectPlans || langMap.en.sharedProjectPlans;
    },
    get space() {
        return langMap[ep.resxCulture].space || langMap.en.space;
    },
    get spaces() {
        return langMap[ep.resxCulture].spaces || langMap.en.spaces;
    },
    get summaryReport() {
        return langMap[ep.resxCulture].summaryReport || langMap.en.summaryReport;
    },
    get support_center() {
        return langMap[ep.resxCulture].support_center || langMap.en.support_center;
    },
    get support_chat() {
        return langMap[ep.resxCulture].support_chat || langMap.en.support_chat;
    },
    get systemLists() {
        return langMap[ep.resxCulture].systemLists || langMap.en.systemLists;
    },
    get timelogs() {
        return langMap[ep.resxCulture].timelogs || langMap.en.timelogs;
    },
    get updateLicense() {
        return langMap[ep.resxCulture].updateLicense || langMap.en.updateLicense;
    },
    get upgrade_now() {
        return langMap[ep.resxCulture].upgrade_now || langMap.en.upgrade_now;
    },
    get users() {
        return langMap[ep.resxCulture].users || langMap.en.users;
    },
    get vacationsreport() {
        return langMap[ep.resxCulture].vacationsreport || langMap.en.vacationsreport;
    },
    get whatif() {
        return langMap[ep.resxCulture].whatif || langMap.en.whatif;
    },
    get workflows() {
        return langMap[ep.resxCulture].workflows || langMap.en.workflows;
    },
};

// @ts-ignore
ep.resources = ep.resources || {};

// @ts-ignore
ep.resources.menu = menuResx;
